import type { EnemyConfig } from '../../entities/EnemyConfig';

export const KANGAROO_CONFIG: EnemyConfig = {
  id: 'kangaroo',
  displayName: 'Кенгуру',
  maxHp: 4,
  speed: 100,
  movementBehavior: 'chase',
  size: 38,
  color: 0xb87333,
  scoreReward: 16,
  spawnsOnDeath: {
    id: 'kangaroo_joey',
    chance: 0.5,
  },
};
